/**
 * Shared Navigation Component - Re-exports Header from HomePage
 * Used across all pages for consistent navigation
 */

import Header from './Header';

// Simply re-export the Header component
export default Header;
